import GridContainer from "../../components/uiKits/grid";

const Grid = () => {
  return <GridContainer />;
};

export default Grid;
